
            window.addEventListener("load", function () {
                initJQuery(function () {
                    if (typeof $ == "undefined") {
                        $ = jQuery;
                    }
                    var setColor = setInterval(function () {
                        if ($(".chat-bubble").length >0) {
                            var chat_bubble = $(".chat-bubble")[0]
                            chat_bubble.contentDocument.getElementsByClassName("chat-widget")[0].style.fill = "#4394F1"
                            chat_bubble.contentDocument.getElementsByClassName("chat-widget")[1].style.fill = "#4394F1"
                            $(chat_bubble).css("inset", "auto 16px 20px auto")
                            var bubble_div = $(chat_bubble).contents().find(".bu1")[0]
                            $(bubble_div).css("background-color", "#4394F1")
                            var chat_content = $(".chat-content")[0]
                            
                            $(chat_content).css("inset", "auto 10px 90px auto")
                            setTimeout(function () {
                                var content_header = $(chat_content).contents().find(".b1")[0]
                                $(content_header).css("background-color", "#4394F1")
                                var title = $(chat_content).contents().find(".b121")[0]
                                $(title).css("color", "#ffffff")
                                $(title).text("Welcome")
                                $(title).prop("title", "Welcome");
                                var intro = $(chat_content).contents().find(".b122")[0]
                                $(intro).css("color", "#ffffff")
                                $(intro).text("Need help? We're here to help!")
                                $(intro).prop("title", "Need help? We're here to help!");
                                var img = $(chat_content).contents().find(".b11")[0]
                                $(img).prop("src", "/omnichat/static/img/NestDesk---Icon-.png")
                                chat_bubble.contentDocument.getElementById("s01").style.display = 'block'                                
                            }, 0)
                            document.getElementsByClassName('chat-bubble')[0].style.opacity = 1
                            clearInterval(setColor);
                        }
                    }, 500);
                })
            });
            
            function initJQuery(e) {
                var t;
                "undefined" == typeof jQuery ? ((t = document.createElement("SCRIPT")).src = "https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js", t.type = "text/javascript", t.onload = e, document.head.appendChild(t)) : e()
            }
        